
import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import discordLogo from '../../assets/images/discord-logo.png';

import { useAuth } from '../../hooks/useAuth';

export const LoginButton: React.FC = () => {
    const { startDiscordAuth, isLoading } = useAuth();

    return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
            <Button
                variant="contained"
                size="large"
                startIcon={
                    <img
                        src={discordLogo}
                        alt="Discord"
                        style={{
                            width: 33,
                            height: 25,
                        }}
                    />
                }
                onClick={startDiscordAuth}
                disabled={isLoading}
                sx={{
                    backgroundColor: '#5865F2',
                    '&:hover': {
                        backgroundColor: '#4752C4'
                    },
                    px: 4,
                    py: 1.5
                }}
            >

                {isLoading ? 'Connecting...' : 'Login with Discord'}
            </Button>
        </Box>
    );
};
